import { Gray_Light_200 } from '@common/styles';

export const ReviewStar32Icon = ({
  width = '32',
  height = '32',
  color = Gray_Light_200,
  ...props
}: JSX.IntrinsicElements['svg']) => (
  <svg width={width} height={height} color={color} viewBox='0 0 32 32' fill='none' {...props}>
    <path
      d='M20.6148 11.0206L30.5 12.4965L23.4618 19.612L25.2262 29.5L16 24.9436L6.77385 29.5L8.53824 19.612L1.5 12.4965L11.3852 11.0206L16 2.5L20.6148 11.0206Z'
      fill='currentColor'
    />
  </svg>
);
